<div class="modal-header hire-modal-header w-100">
  <div class="d-flex justify-content-between text-defualt w-100">
    <span class="d-flex align-items-center">
      <img src="../../assets/images/eu_access_logo.png" alt="" class="mr-2" style="width: 20px;height:20px">
      <span class="font-weight-600 f-12">Europe Data Access Confirmation</span>
    </span>
    <span class="f-14 font-weight-600 pointer" (click)="closeModal()">
      <span><i class=" fa-solid fa-times"></i></span>
    </span>
  </div>
</div>


<div class="modal-body px-5 pb-0 pt-4">
  <div class="">
    <div class="">
      <p class="f-12 text-9696">You are about to access EU data. Please confirm your agreement to follow our data protection and handling guidelines
      </p>
    </div>
    <div>
      <div class="d-flex mb-3 f-12">
        <label class="eu-checkbox mr-3 mb-0">
          <input data-testid="auto-app-europe-access-modal-input-1" type="checkbox" (change)="changeEUCheckbox($event)" [formControl]="euCheckbox">
         </label>
        <div class="f-12 font-weight-500">
            I acknowledge and agree to the <span class="acknowledge-data" (click)="openPdf()">data handling and privacy guidelines.</span>
        </div>

      </div>
  <p class="f-12" *ngIf="(euCheckbox?.errors?.required && (euCheckbox?.dirty || euCheckbox?.touched)) || showRequiredError"
              [ngClass]="['text-left','my-1','text-danger']">Please acknowledge first.</p>
    </div>
    <div class="row pb-4">
      <div class="col text-right" >
        <button data-testid="auto-app-europe-access-modal-button-1" type="button" class="btn-trms-medium" data-dismiss="modal" [disabled]="euCheckbox?.value != true"
        [ngClass]="{'disabled-btn': euCheckbox?.value != true}"
          (click)="getEUAcknowledge()">Proceed</button>
      </div>
    </div>
  </div>
</div>
